// all colors
var COLORS = {
    lightPink: "#ffe4f2",
    cupid: "#FFB4DA",
    pink: "#ff0083",
    darkPink: "#dc0073",
    darkerPink: "#b40060",
    lightRed: "#F83157",
    red: "#F7274A",
    darkRed: "#EC092F",
    darkerRed: "#D82140",
    orange: "#FFB01C",
    green: "#2AD5BD",
    java: "#27C7B0",
    caribbeanGreen: "#24B8A3",
    blue: "#2A76E4",
    darkBlue: "#225AAF",
    darkerBlue: "#174991",
    black: "#000000",
    void: "#262626",
    darkNight: "#2b2b2b",
    darkerNight: "#282828",
    darkestNight: "#161616",
    grayNight: "#524751",
    night: "#4a4a4a",
    nightRider: "#313131",
    matterhorn: "#525252",
    darkMineShaft: "#202020",
    boulder: "#7b7b7b",
    darkGray: "#a9a9a9",
    dark: "#9b9b9b",
    metal: "#b7b7b7",
    solidGray: "#d8d8d8",
    gainsboro: "#dbdbdb",
    light: "#dadada",
    veryLightGrey: "#cccccc",
    pebble: "#d9d9d9",
    aliceBlue: "#f6f7f8",
    snowy: "#fcfcfc",
    glass: "#ececec",
    mercury: "#e7e7e7",
    cloud: "#f7f7f7",
    pearl: "#fdfdfd",
    white: "#ffffff",
    gray: "#8C8C8C",
    concrete: "#f3f3f3",
    mineShaft: "#333333",
    alto: "#E0E0E0",
    darkestRed: "#C60442",
    scarlet: "#f83157",
    buttercup: "#f5a623",
    malachite: "#00CB5B",
    listerine: "#27D8B5",
    havelockBlue: "#4a90e2",
    blueGray: "#6c87a8",
    blueSky: "#319bf5",
    lighterCloud: "#fbfbfb",
    orangePill: "#FF9900",
    whiteSmoke: "#F5F5F5",
    mouseGray: "#9B9B9B",
    yellow: "#FFE071",
    lightYellow: "#fff3c7",
    mediumSea: "#2ECC71",
    nero: "#141414",
    mirage: "#171930",
    ebonyClay: "#222540",
    rhino: "#2F335B",
    eastBay: "#42508A",
    chetwodeBlue: "#92ABDC",
    strikemaster: "#9E6D8F",
    eggplant: "#643B5B",
    hemlock: "#64583B",
    shadow: "#847654",
    turquoise: "#2AD5BD",
    poloBlue: "#90A8D9",
    cottonCandy: "#FEAED8",
    pastelPink: "#FFD1E8",
    tutu: "#FFF7FB",
    hoki: "#6380A3",
    barleyWhite: "#fff3c7",
    blond: "#FFE071",
    meteor: "#D18313",
    sandyBeach: "#FFEECE",
    bostonBlue: "#4391BD",
    zumthor: "#EBF5FF",
    pippin: "#ffe3e3",
    pinkLady: "#fff2da",
    frostedMint: "#DBFFEC",
    eucalyptus: "#1D9F58",
    lavenderBlush: "#FFEAF4",
    lotus: "#824040",
    vividTangerine: "#FF7E7E",
    domino: "#928163",
    salomie: "#FFDB95",
    falcon: "#775570",
    carnationPink: "#FF8EC9",
    doveGray: "#666363",
    cuttySark: "#577A71",
    algaeGreen: "#9ADFC6",
    ebony: "#0F1125",
    cornflowerBlue: "#6195ED",
    anakiwa: "#B3D9FF",
    angelDrop: "#EBF5FF",
    blueBayoux: "#485F6A",
    fireBush: "#E3A831",
    winterSalt: "#ADAEC2",
    beforeNightfall: "#9497B2",
    lavender: "#6C709C",
    tintedBlue: "#5A5E8C",
    kinglyCloud: "#DCDCDC",
    paleGray: "#E4E4E4",
    palePink: "#FFD9ED",
    lightGray: "#DEDEDE",
    dividerGray: "#797979",
    brightBlue: "#4a3fd9",
    lightGrayishBlue: "#CAD3FB",
    lighterGrayishBlue: "#EFF3FE"
};

export { COLORS };
